import React, { useState } from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { createPortal } from "react-dom"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import ModalNova from "@nutrafol/nutrafol-ui-kit/dist/ModalNova"

import SubscriptionIncludesModal from "./subscriptionincludesmodal"

import { data } from "../../../../../data/data_headspace_nova"

// Modal Overrides
const Wrapper = styled.div`
  #Modal {
    max-width: 1096px !important;
  }
`

const SubscriptionIncludes = ({ pb = 16 }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleViewModal = () => {
    segmentEvent("Modal Viewed", {
      name: "More Details",
    })
    setModalOpen(true)
  }

  return (
    <Wrapper>
      <Box py={16} className="border-b border-nova-transparency-black-20">
        <TextElementNova
          text={data.heading}
          classes={{
            default: "Body-10-Dia-Strong",
            768: "Body-20-Dia-Strong",
            1024: "Body-20-Dia-Strong",
          }}
        />
      </Box>
      {data.items.map((item, index) => {
        const Icon = item.image
        return (
          <Flex
            key={item.heading}
            alignItems="center"
            py={14}
            pr={8}
            className="border-b border-nova-transparency-black-20"
          >
            <Box width={[20, 20, 32]} height={[20, 20, 32]} mr={[8, 8, 16]}>
              <Icon width="100%" height="100%" />
            </Box>
            <Box flex="1">
              <TextElementNova
                text={item.text}
                classes={{
                  default: "Body-10-Dia-Normal",
                  768: "Body-20-Dia-Normal",
                  1024: "Body-20-Dia-Normal",
                }}
              />
            </Box>
          </Flex>
        )
      })}
      <Box pt={16} pb={pb}>
        <ButtonNova
          label={data.buttonText}
          level={"Textlink"}
          onClick={handleViewModal}
        />
      </Box>
      {modalOpen
        ? createPortal(
            <ModalNova
              hideModal={() => setModalOpen(false)}
              size="large"
              title={data.modalHeading}
            >
              <SubscriptionIncludesModal data={data} />
            </ModalNova>,
            document.body
          )
        : null}
    </Wrapper>
  )
}

export default SubscriptionIncludes
